import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import AwardRepository from '../Repositories/AwardRepository'

class AwardBloc {

    rowtableChannel = new Subject();
    inactiveChannel = new Subject();
    activeChannel = new Subject();
    periodeChannel = new Subject();
    periodeOptionChannel = new Subject();
    typeChannel = new Subject();
    signatoriesChannel = new Subject();
    detailChannel = new Subject();
    repository = new AwardRepository()

    constructor() {
        this.rowtableChannel.next({status: apiResponse.INITIAL})
        this.inactiveChannel.next({ status: apiResponse.INITIAL })
        this.activeChannel.next({ status: apiResponse.INITIAL })
        this.periodeChannel.next({ status: apiResponse.INITIAL })
        this.typeChannel.next({ status: apiResponse.INITIAL })
        this.signatoriesChannel.next({ status: apiResponse.INITIAL })
        this.detailChannel.next({ status: apiResponse.INITIAL })
    }

    fetchRowTable = async (query, cancelToken) => {
        try {
            this.rowtableChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTable(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
           console.log('rxjs', 'Table unsubscribed') 
        }
    }

    fetchPeriode = async (query) => {
        try {
            this.periodeChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchPeriode(query).then((result) => {
                this.periodeChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.periodeChannel.next({ status: apiResponse.ERROR, data: error })
            })   
        } catch (error) {
            console.log('rxjs', 'Award Periode Channel Unsubscribed') 
        }
    }
    fetchPeriodeOption = async (query) => {
        try {
            this.periodeOptionChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchPeriodeOption(query).then((result) => {
                this.periodeOptionChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.periodeOptionChannel.next({ status: apiResponse.ERROR, data: error })
            })   
        } catch (error) {
            console.log('rxjs', 'Award Periode Channel Unsubscribed') 
        }
    }
    fetchType = async (query) => {
        try {
            this.typeChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchType(query).then((result) => {
                this.typeChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.typeChannel.next({ status: apiResponse.ERROR, data: error })
            })   
        } catch (error) {
            console.log('rxjs', 'Award Type Channel Unsubscribed') 
        }
    }

    fetchSignatories = async (query) => {
        try {
            this.signatoriesChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchSignatories(query).then((result) => {
                this.signatoriesChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.signatoriesChannel.next({ status: apiResponse.ERROR, data: error })
            })   
        } catch (error) {
            console.log('rxjs', 'Signatories Official Channel Unsubscribed') 
        }
    }

    fetchInactive = async (query) => {
        try {
            this.inactiveChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInactive(query).then((result) => {
                this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Award Inactive Channel Unsubscribed') 
        }
    }

    fetchActive = async (query) => {
        try {
            this.activeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchActive(query).then((result) => {
                this.activeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.activeChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Award Active Channel Unsubscribed') 
        }
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.detailChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Detail Award Channel Unsubscribed')
        }
    }

}

export default AwardBloc
